import { motion } from "@smartsheet/design-tokens";
import { color } from "@smartsheet/design-tokens-react";
import { themed } from "@smartsheet/sds-theme-internal";
import { buttonPrimary } from "../../constants/colors";
import { sizes } from "../../constants/spacing";

export const tabsTheme = themed({
    canvas: {
        textColor: color("color--text--slate--strong"),
        underlineColor: color("color--border--slate--weakest"),
        underlineHoverColor: {
            "lodestar-light": color("color--border--slate--strong"),
            "ursa-light": color("color--border--slate--weaker"),
        },
        activeTextColor: {
            "lodestar-light": color("color--text--slate--strong"),
            "ursa-light": `var(--sds--link--color--rest, ${color("color--text--slate--strong")})`,
        },
    },
    "work-surface": {
        textColor: color("color--text--neutral--default"),
        underlineColor: color("color--border--neutral--weakest"),
        underlineHoverColor: {
            "lodestar-light": color("color--border--neutral--strong"),
            "ursa-light": color("color--border--neutral--weaker"),
        },
        activeTextColor: {
            "lodestar-light": color("color--text--neutral--default"),
            "ursa-light": `var(--sds--link--color--rest, ${color("color--text--neutral--default")})`,
        },
    },
    selectedTextColor: {
        "lodestar-light": color("color--text--neutral--strong"),
        "ursa-light": color("color--text--primary--default"),
    },
    disabledTextColor: color("color--text--neutral--weaker"),
    underlineHeight: {
        default: {
            "lodestar-light": "2px",
            "ursa-light": "1px",
        },
        active: {
            "lodestar-light": "2px",
            "ursa-light": "3px",
        },
    },

    underlineSelectedColor: {
        "lodestar-light": buttonPrimary,
        "ursa-light": color("color--border--primary--default"),
    },
    underlineAnimation: {
        "lodestar-light": "",
        "ursa-light": motion.easing.default,
    },
    font: {
        weight: {
            "lodestar-light": "600",
            "ursa-light": "500",
        },
        lineHeight: "18px",
    },
    containerHeight: {
        "lodestar-light": `${sizes.large}px`,
        "ursa-light": "36px",
    },
    focusRingRadius: {
        "lodestar-light": "4px",
        "ursa-light": 0,
    },
    focusRingGap: {
        "lodestar-light": 2,
        "ursa-light": 8,
    },
    focusRingRadiusOverride: {
        "lodestar-light": "0",
        "ursa-light": "8px",
    },
    focusRingInsetOverride: {
        "lodestar-light": "",
        "ursa-light": "0px",
    },
    tabMarginLeft: {
        "lodestar-light": `${sizes.xLarge}px`,
        "ursa-light": `${sizes.large}px`,
    },
});
